import { useConsent } from '@/providers/consent-provider'
import { CookieConsentBanner } from './CookieConsentBanner'
import { CookiePreferences } from './CookiePreferences'

/**
 * Mounts the consent banner + preferences modal, wired to the ConsentProvider.
 * Render once near the root. Renders nothing until the provider has hydrated on
 * the client, so prerendered HTML carries no consent markup.
 */
export function CookieConsent() {
  const {
    categories,
    hasResponded,
    ready,
    preferencesOpen,
    acceptAll,
    rejectAll,
    savePreferences,
    openPreferences,
    closePreferences,
  } = useConsent()

  if (!ready) return null

  return (
    <>
      <CookieConsentBanner
        show={!hasResponded && !preferencesOpen}
        onAcceptAll={acceptAll}
        onRejectAll={rejectAll}
        onManage={openPreferences}
      />
      <CookiePreferences
        open={preferencesOpen}
        initial={categories}
        onSave={savePreferences}
        onAcceptAll={acceptAll}
        onRejectAll={rejectAll}
        onClose={closePreferences}
      />
    </>
  )
}

export { useConsent } from '@/providers/consent-provider'
